import { Figure } from "@/components/site/primitives";
import {
  RetrievalFusionDiagram,
  IngestionDiagram,
  CitedAnswerDiagram,
  StrataDiagram,
  MembraneDiagram,
  MemoryGraphDiagram,
} from "@/components/site/Diagrams";

const FIGS = {
  RetrievalFusion: RetrievalFusionDiagram,
  Ingestion: IngestionDiagram,
  CitedAnswer: CitedAnswerDiagram,
  Strata: StrataDiagram,
  Membrane: MembraneDiagram,
  MemoryGraph: MemoryGraphDiagram,
};

export const ReadingHero = ({ eyebrow, title, meta, abstract }) => (
  <header className="border-b border-ink/10 bg-bone">
    <div className="mx-auto max-w-[880px] px-5 pb-14 pt-32 md:px-8 md:pb-20 md:pt-44">
      <span className="eyebrow">{eyebrow}</span>
      <h1 className="mt-6 text-balance font-serif text-4xl leading-[1.05] tracking-tighter text-ink md:text-6xl">{title}</h1>
      {meta && <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-xs text-ink/50">{meta}</div>}
      {abstract && <p className="mt-8 max-w-measure font-serif text-xl italic leading-[1.6] text-ink/70">{abstract}</p>}
    </div>
  </header>
);

const Blocks = ({ content }) => (
  <>
    {content.map((b, i) => {
      if (b.t === "p")
        return (
          <p key={i} className="mt-7 font-serif text-[19px] leading-[1.75] text-ink/85">
            {b.c}
          </p>
        );
      if (b.t === "h")
        return (
          <h2 key={i} className="mt-16 font-serif text-2xl tracking-tight text-ink md:text-3xl">
            {b.c}
          </h2>
        );
      if (b.t === "quote")
        return (
          <blockquote key={i} className="my-12 border-l-2 border-saffron pl-6 font-serif text-2xl italic leading-snug text-ink md:text-3xl">
            {b.c}
          </blockquote>
        );
      if (b.t === "list")
        return (
          <ul key={i} className="mt-7 space-y-3">
            {b.items.map((it, j) => (
              <li key={j} className="flex gap-3 font-serif text-[18px] leading-[1.6] text-ink/85">
                <span className="mt-3 h-1.5 w-1.5 flex-shrink-0 bg-saffron" />
                {it}
              </li>
            ))}
          </ul>
        );
      if (b.t === "code")
        return (
          <pre key={i} className="my-8 overflow-x-auto border border-ink/15 bg-ink p-5 font-mono text-[13px] leading-relaxed text-bone">
            <code>{b.c}</code>
          </pre>
        );
      if (b.t === "stat")
        return (
          <div key={i} className="my-12 grid grid-cols-2 gap-8 border-y border-ink/10 py-10 md:grid-cols-3">
            {b.items.map((s, j) => (
              <div key={j}>
                <div className="font-serif text-4xl tracking-tight text-ink">{s.v}</div>
                <div className="mt-2 text-sm text-ink/55">{s.l}</div>
              </div>
            ))}
          </div>
        );
      if (b.t === "fig") {
        const D = FIGS[b.fig];
        return (
          <Figure key={i} n={b.n} caption={b.caption} light>
            {D ? <D className="text-ink/70" /> : null}
          </Figure>
        );
      }
      return null;
    })}
  </>
);

export const LongFormBody = ({ content }) => (
  <div className="bg-bone">
    <article className="mx-auto max-w-[720px] px-5 py-16 md:px-8 md:py-24">
      <Blocks content={content} />
    </article>
  </div>
);
